import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import NavbarTop from 'components/navbar/top/NavbarTop';
import NavbarVertical from 'components/navbar/vertical/NavbarVertical';
import Footer from 'components/footer/Footer';
import ProductProvider from 'providers/ProductProvider';
import CourseProvider from 'providers/CourseProvider';
import { MenuBadgeProvider } from 'providers/MenuBadgeProvider';
import ModalAuth from 'components/authentication/modal/ModalAuth';
import ForcePasswordChange from 'components/authentication/ForcePasswordChange';

import { useAppContext } from 'providers/AppProvider';

const MainLayout = () => {
  const { hash, pathname } = useLocation();
  const isKanban = pathname.includes('kanban');
  // const isChat = pathname.includes('chat');

  const {
    config: { isFluid, navbarPosition }
  } = useAppContext();

  const isServiceMap = pathname.includes('service-map');

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    // MenuBadgeProvider — внутри MainLayout (после auth-guard'a PrivateRoute),
    // чтобы интервал polling'а счётчиков AML/KYC жил только пока юзер залогинен.
    // На /login и /404 провайдер не маунтится → нет 401-loop'а после logout
    // (см. ARCH-review #4 от 2026-05-18, RFC-004).
    <MenuBadgeProvider>
      <div className={isFluid || isServiceMap ? 'container-fluid' : 'container'}>
        {(navbarPosition === 'vertical' || navbarPosition === 'combo') && (
          <NavbarVertical />
        )}
        <ProductProvider>
          <CourseProvider>
            <div className={classNames('content', { 'pb-0': isKanban || isServiceMap })}>
              <NavbarTop />
              {/*------ Main Routes ------*/}
              <Outlet />
              {!isKanban && !isServiceMap && <Footer />}
            </div>
          </CourseProvider>
        </ProductProvider>
        <ModalAuth />
        <ForcePasswordChange />
      </div>
    </MenuBadgeProvider>
  );
};

export default MainLayout;
